import { useEffect } from 'react';

/**
 * Removes the reapply query parameter.
 * This should not be present on new applications.
 */
const useCleanQueryParams = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.has('reapply')) {
      params.delete('reapply');
      const url = new URL(window.location);
      url.search = params.toString();
      window.history.replaceState(null, '', url);
    }
  }, []);
};

export default useCleanQueryParams;
